import styled, { css } from 'styled-components'
import { colors, media } from 'client/styles'

export const LoginNavigatorBase = styled.nav`
  ${media.tablet} {
    position: absolute;
    inset-block-start: 38px;
    z-index: var(--z-high);
    background-color: ${colors.white};
    inset-inline-start: calc(100% - 170px);
    width: 200px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);
  }
`

export const NavigatorHeader = styled.div`
  padding-block: 20px;
  padding-inline: 20px;
  border-block-end: 1px solid ${colors.grey6};

  > h3 {
    font-size: 20px;
    font-weight: 700;
    margin-block-end: 16px;
  }
`

export const NavigatorList = styled.ul`
  li {
    border-block-end: 1px solid ${colors.grey6};
  }
`

export const Section = styled.a`
  cursor: pointer;
  display: block;
  padding-block: 16px;
  padding-inline: 16px;
  text-decoration: none;

  &:hover {
    background-color: ${colors.grey6};
  }

  ${props =>
    props.id === 'link' &&
    css`
      background-color: ${colors.white};
      color: ${colors.grey1};
      font-weight: 500;
    `}

  ${props =>
    props.id === 'logout' &&
    css`
      background-color: ${colors.white};
      color: ${colors.red};
      font-weight: 700;
    `};
`
